/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */

import React from "react";

import closeIcon from "../../icons/closeIcon.png";
import onlineIcon from "../../icons/onlineIcon.png";

import './InfoBar.css';

const InfoBar = ({room}) => {
    return(
    

    <div className="infoBar">
        <div className ="leftInnerContainer">
            <img className="onlineIcon" src={onlineIcon} alt="online image" />
            <h3>{room}</h3>
        </div>
        <div className = "rightInnerContainer" >
            <a herf="/" > <img src={closeIcon} alt="close Image" /> </a>

        </div> 
    </div>
    
    )}

export default InfoBar;